import React from 'react';
import { Button, Divider } from 'antd';
import { Catalog, Star } from '../../../component';
import LinesEllipsis from 'react-lines-ellipsis';
import styles from './index.css';
import env from '../../../lib/env';
import done_pic from '../../../asset/book/done.png';
import not_done_pic from '../../../asset/book/not_done.png';

export default class Info extends React.Component {

    state = {
        show_catalog: false,
    }

    goto_read = () => {
        const { novel_id, last_read_order_num } = this.props;
        let path = `/book/read/${novel_id}`;
        if (last_read_order_num >= 0) {
            path = path + '/' + last_read_order_num;
        }
        env.goto_page(path);
    }

    render() {
        const {
            pic,
            novel_name,
            tag_name,
            author_name,
            summary,
            words_num,
            read_num,
            in_bookshelf,
            is_done,
            score,
        } = this.props;


        return (
            <div style={{
                position: 'relative',
                height: '207px',
            }}>
                <img alt='' src={Number(is_done) ? done_pic : not_done_pic} style={{
                    position: 'absolute',
                    left: '108px',
                    top: '155px',
                    width: '52px',
                    height: '52px',
                }} />
                <img alt='' src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ position: 'absolute', left: '0', top: '0', width: '100px' }} />
                <img alt="" src={pic} style={{
                    width: '160px',
                    height: '207px',
                    float: 'left',
                }} />
                <div style={{
                    position: 'relative',
                    marginLeft: '180px',
                }}>
                    <div style={{
                        fontSize: '26px',
                        lineHeight: '37x',
                        color: '#333333',
                    }}>
                        <LinesEllipsis text={novel_name} maxLine={1} />
                    </div>
                    <div style={{
                        marginTop: '10px',
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: '#999999',
                    }}>
                        {tag_name}<Divider type="vertical" />{author_name}
                    </div>
                    <div className={styles.summary} style={{
                        marginTop: '10px',
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: '#999999',
                        height: '60px',
                        overflowY: 'scroll',
                    }}>{(summary || '').split('\n').map((sum_text, idx) => <div key={idx}>{sum_text}</div>)}</div>
                    <div className={styles.button}>
                        <Button type='primary' onClick={this.goto_read}>免费阅读</Button>
                        <Button onClick={() => {
                            this.setState({ show_catalog: true })
                        }}>查看目录</Button>
                        {/* {in_bookshelf
                    ? <Button disabled>已在书架</Button>
                    : <Button onClick={this.props.add_collect}>加入书架</Button>
                } */}
                    </div>
                    {/* <div style={{
                    position: 'absolute',
                    right: '0px',
                    top: '5px',
                }}>
                    <div className={styles.number}>{score<=0?<span>评分人数不够</span>:<Star score={score} />}</div>
                    <div className={styles.number}>{read_num}<span>点击</span></div>
                    <div className={styles.number}>{words_num}<span>字</span></div>
                </div> */}
                </div>
                <Catalog
                    novel_id={this.props.novel_id}
                    show={this.state.show_catalog} onCancel={() => {
                        this.setState({ show_catalog: false });
                    }}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/detail/info.js